import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import Slider from 'components/common/Slider/Slider';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.types';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Filters.module.scss';

export const WbsLevel = ({ isSelected, onFiltersChanged }) => {
    const { control } = useFormContext<IFields>();
    const wbsLevelLabelFormat = (value) => {
        return <div>{value === 10 ? `${value}+` : value}</div>;
    };
    return isSelected ? (
        <div className={classes.selectWrapper}>
            <span className={classes.title}>WBS Level</span>
            <div className={classes.sliderWrapper}>
                <Controller
                    render={({ field }) => (
                        <Slider
                            id={'battlecards-filters-wbslevel-slider'}
                            {...field}
                            step={1}
                            min={1}
                            max={10}
                            valueLabelDisplay={'on'}
                            onChangeCommitted={(_e, value) => {
                                field.onChange(value);
                                onFiltersChanged({ [field.name]: value });
                            }}
                            valueLabelFormat={wbsLevelLabelFormat}
                        />
                    )}
                    name={'wbsLevel'}
                    control={control}
                />
            </div>
        </div>
    ) : null;
};
